<template><!-- 關聯產品 -->
  <div>
    <h3>設定關聯產品</h3>
    <div class="h4 py-5">
      有勾選的產品型號才會出現在Story內頁[獨立設定和Application關聯無關]
    </div>
    <!-- BU -->
    <div class="form-item d-flex py-5">
      <label class="w-240px mr-5"><h4>BU</h4></label>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <v-autocomplete
          v-model="story.bu_id"
          :items="buTabs"
          placeholder="請選擇所屬BU"
          item-text="name"
          item-value="id"
          outlined
          dense
        >
        </v-autocomplete>
      </div>
    </div>
    <!-- 關聯產品 -->
    <div class="d-flex pa-5 brand-100">
      <label for="filterTitleAdd"><h4 class="mr-5">添加產品</h4></label>
      <div class="d-flex my-n2 flex-grow-1">
        <div class="where-to-buy-autocomplete flex-grow-1">
          <v-autocomplete
            :items="categories"
            v-model="tempCategory"
            placeholder="搜尋Category Name"
            item-value="id"
            item-text="name"
            style="background: white;"
            return-object
            outlined
            dense
          >
          </v-autocomplete>
        </div>
        <div class="ml-5">
          <button
            v-if="tempCategory"
            class="btn btn-primary w-90px ml-5"
            @click="addCategory">
            新增
          </button>
          <button v-else class="btn btn-primary w-90px ml-5" disabled>
            新增
          </button>
        </div>
      </div>
    </div>
    <!-- 分類名稱與底下產品 -->
    <div
      v-for="(categoryItem, i) in story.categories"
      :key="categoryItem.category">
      <div
        class="form-item d-flex h-64px align-center justify-space-between">
        <h4>{{ categoryItem.name }}</h4>
        <button class="btn square" @click="deleteCategory(i)">
          <v-icon>delete</v-icon>
        </button>
      </div>
      <!-- products -->
      <div class="form-item mt-5">
        <div
          v-for="product in categoryItem.products"
          :key="product.id">
          <!-- productName -->
          <div>
            <v-checkbox v-model="product.isChecked">
              <template v-slot:label>
                <div class="h5 ink-01-emphasis--text">
                  {{ product.text }}
                </div>
              </template>
            </v-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';

export default {
  components: {
  },
  data: () => ({
    // 添加產品型號
    categories: [],
    tempCategory: null,
  }),
  computed: {
    ...mapState(['buTabs']),
    ...mapState('language', ['countries']),
    ...mapState('story', ['story']),
  },
  async created() {
    this.categories = await this.allByBu();
  },
  watch: {
    async 'story.bu_id'() {
      this.categories = await this.allByBu(this.story.bu_id);
    },
  },
  methods: {
    ...mapActions('category', ['allByBu']),
    addCategory() {
      const hasCategory = this.story.categories.find((category) => category.id === this.tempCategory.id);
      if (hasCategory) {
        this.tempCategory = null;
        return;
      }
      const { id, name } = this.tempCategory;
      const tempProducts = this.tempCategory.products;
      const products = tempProducts.map((product) => {
        product.isChecked = false;
        return product;
      });

      const template = {
        id, name, products,
      };
      this.story.categories.push(JSON.parse(JSON.stringify(template)));
      this.tempCategory = null;
    },
    deleteCategory(i) {
      this.story.categories.splice(i, 1);
    },
  },
};
</script>
<style lang="scss">
.where-to-buy-autocomplete {
  .v-autocomplete {
    .v-input__slot {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    .v-text-field__details {
      display: none;
    }
  }

  // border
  fieldset {
    border-color: #d7dee7;
    background: white;
    border-radius: 8px;
  }
  .v-input--is-focused {
    border-color: $brand-500;
  }

  // placeholder color
  input::placeholder {
    color: #848fa0 !important;
    font-size: 16px;
    line-height: 1.43;
  }
}
</style>
